import React from 'react';
import { Redirect } from 'react-router-dom';
import { IAuthGateProps } from './types';
import useGetMe from '../../hooks/useCurrentUser';
import { AreaPermissions, canAny } from '../../config/permissions';

const AuthGate: React.FC<IAuthGateProps> = (props: IAuthGateProps) => {
  const { isUserAuthenticated, children } = props;
  const user = useGetMe();

  if (!isUserAuthenticated) {
    return (
      <Redirect to="/login" />
    );
  }

  // O userType escolhe a área; a permissão decide se ele entra nela. As rotas
  // das áreas se sobrepõem, então trocar o userType por permissão aqui faria
  // duas áreas casarem o mesmo caminho.
  if (isUserAuthenticated && user.userType === 1 && canAny(...AreaPermissions.pessoaFisica)) {
    return (
      <>
        {children}
      </>
    );
  }

  return (
    <Redirect to="/" />
  );
};

export default AuthGate;
